var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('div',{staticClass:"wechat-tips",on:{"click":function($event){return _vm.close()}}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/imgs/common/icon-wechat-tip.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }